export default __webpack_public_path__ + "static/media/trash-black.23284c99.svg";